/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useRef, useState } from "react";
import NavigationBar from "../common/NavigationBar";
import Footer from "../common/Footer";
import ContactSection from "../common/ContactAs";

const HowItWorksPage = () => {
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const offersRef = useRef(null);
  const contactRef = useRef(null);
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="terms-container">
      <NavigationBar
        homeRef={homeRef}
        aboutRef={aboutRef}
        servicesRef={servicesRef}
        offersRef={offersRef}
        contactRef={contactRef}
      />

      <section id="terms-conditions" className="terms-section">
        <article className="terms-header-content">
          <div className="how-its-container">
          <h1>How it works</h1>
          <h4>
            Turn Your{" "}
            <span className="highlight-rate highlight-color">Experiences</span>{" "}
            into a{" "}
            <span className="highlight-rate highlight-color">
              Perfecterience
            </span>{" "}
            with <span className="highlight-rate">RIGHT LENDER.</span>{" "}
          </h4>
          </div>
          <div className="how-its-para">
          <p>
            <span className="highlight-rate">Right Lender</span> is a digital facilitation platform developed by
            <span className="highlight-rate highlight-color">Perukkal 100 Consultancy Private Limited</span> (CIN-U66190TZ2024PTC031218)
            created after extensive research and real borrower feedback.
            Designed to simplify and guide loan seekers,
          </p>
          <p>
            Right Lender is committed to delivering smart, reliable financial
            solutions by blending modern technology with a dedicated team that
            brings over 20 years of industry experience. With a new-age approach
            and specialized experts for each loan product, we combine expertise,
            experience, and technology — all in one place. By combining human
            insight with advanced tech, Right Lender helps you find the perfect
            financial match, tailored to your unique profile
          </p>
          <p>
            Right Lender is associated with 65+ top Banks and NBFCs, offering a
            full range of loan solutions including Personal Loans, Business
            Loans, Doctor Loans, NRI Loans, Balance Transfer, Mortgage Loans,
            and Home Loans. We don’t just assist with loan disbursement—we also
            support you with post-loan services such as Top-up Loans and Balance
            Transfers. Our intelligent system analyses your profile in real-time
            and matches it with the most relevant lenders based on their latest
            credit policies— <span className="highlight-rate">helping you avoid unnecessary rejections, CIBIL
            score impact, and time delays.</span>
          </p>
          <p>
            Right Lender is powered by a team of professionals with strong
            technical and product expertise. <span className="highlight-rate">Each loan product is handled by a
            dedicated expert team, ensuring your application is evaluated
            accurately and sent only to the most suitable lender.</span> We assist you
            at every step—from application to disbursement. If your profile
            doesn't meet any lender’s criteria, we’ll inform you, reject the
            application responsibly, and guide you on how to become eligible in
            the future. To deliver a seamless experience, we’ve built a robust
            digital infrastructure that ensures high performance and user
            satisfaction . Right Lender is accessible via web, Android, and iOS
            platforms, allowing you to explore, track, and apply for loans
            anytime, anywhere.
          </p>
          <p className="how-its-address">
            Please Note: Right Lender is not registered with the RBI as a lender
            or NBFC. <span className="highlight-rate">We act as a corporate channel partner with Starpowerz Human
            Resources Pvt Ltd</span>
          </p>
          <p className="how-its-address">
            Address: Plot No. 5-9-30/5/1101 , 11th Level, Paigah Plaza, Opposite
            Balaji Grand Bazaar, Basheer Bagh, Palace Colony Rd, Hyderabad,
            Telangana 500063.
          </p>
          <p>
            We work with 65+ leading Banks and NBFCs. All loan approvals and
            disbursements are subject to the internal credit policies of the
            respective financial institutions. Thank you for trusting Right
            Lender. We're honored to be a part of your financial journey. ❤️
          </p>
          </div>
        </article>
      </section>
      {/* Contact Section */}
      <section ref={contactRef}>
        <ContactSection
          scrollToSection={scrollToSection}
          homeRef={homeRef}
          aboutRef={aboutRef}
          servicesRef={servicesRef}
          contactRef={contactRef}
        />
      </section>
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HowItWorksPage;
